import { MegaphoneIcon, XMarkIcon } from '@heroicons/react/24/outline'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { useBasket } from '../../providers/basket'

const msg = {
  '/permanent-makeup/': {
    text: 'Buy One, Receive a Free Top-Up',
    ctaURL: '/promotions/',
    ctaText : 'Book Promotions'
  },
  '/flash-sales/': {
    text: 'Discover Our Latest PROMOTIONS',
    ctaURL: '/promotions/',
    ctaText : 'Book Promotions'
  },
  // '/laser-hair-removal/': {
  //   text: 'Get 60% Off Any Single Laser Treatment with code LASER60',
  //   ctaURL: '/promotions/',
  //   ctaText : 'More Promotions'
  // },
  // '/treatments/face/': {
  //   text: 'Get 25% off facials with code SPRINGFACE',
  // },
  // '/treatments/body/': {
  //   text: 'Get 50% off body with code NYBODY50',
  // },
  // '/skin-boosters/': {
  //   text: 'Get 25% off injectables with code NYINJECT',
  // },
  // '/dermal-fillers/': {
  //   text: 'Get 25% off injectables with code NYINJECT',
  // },
  // '/anti-wrinkle-injections/': {
  //   text: 'Get 25% off injectables with code NYINJECT',
  // },
  // '/permanent-makeup/': {
  //   text: 'Get 25% off permanent makeup for bookings in June',
  // },
}

export default function FixedBanner({ router }) {
  const [dismiss, setDismissed] = useState<string | boolean>(true)
  const { addItem } = useBasket()
  //console.log('router', router.pathname)
  const m = msg[router.asPath]
    ? msg[router.asPath]
    : {
        text: 'FLASH SALE is HERE!',
        ctaURL: '/flash-sales/',
        ctaText : 'Book Now'
      }

  // text: 'BLACK FRIDAY is here! 50% off all treatments with code BF50',
  //  useEffect(() => {
  //   const value = localStorage.getItem('cl.offer.banner6')
  //   setDismissed(!!value)

  //   setTimeout(() => {
  //     setDismissed(true)
  //   }, 60 * 1000)
  // }, [])

  // if (dismiss || router.pathname.includes('booking')) {
  //   return null
  // }

  const close = () => {
    localStorage.setItem('cl.offer.consultations', 'y')
    setDismissed(true)
  }

  if (!m) return null

  const [timeLeft, setTimeLeft] = useState<string>("")
  
  useEffect(() => {
    const targetDate = new Date("2025-05-05T00:00:00")

    const updateCountdown = () => {
      const now = new Date()
      const diff = Math.max(0, Math.floor((targetDate.getTime() - now.getTime()) / 1000))
      const days = Math.floor(diff / 86400); // 1 day = 86400 seconds
      const hours = Math.floor((diff % 86400) / 3600);
      const minutes = Math.floor((diff % 3600) / 60);
      const seconds = diff % 60;

      setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
    }

    updateCountdown() // Run immediately
    const interval = setInterval(updateCountdown, 1000)
    return () => clearInterval(interval)
  }, [])
  
  return (
    <div className="bg-brand-600">
      <div className="mx-auto max-w-7xl py-1 px-3 sm:px-6 lg:px-8">
        {/* SHOW BANNER */} 
        {m.text &&
        <div className="flex flex-wrap items-center justify-between">
          <div className="flex w-0 flex-1 items-center">
            <span className="flex rounded-lg bg-brand-800 p-2">
              <MegaphoneIcon
                className="h-6 w-6 text-white"
                aria-hidden="true"
              />
            </span>
            <p className="ml-3 font-medium text-white">
              <span className="md:hidden">{m.text}</span>
              <span className="hidden md:inline font-semibold">{m.text}</span>
              {/* COUNTDOWN TIMER AFTER TEXT 
              <span className="ml-1 text-white ">Hurry! This promotion ends in </span>
              <span className="text-red-600 font-semibold">{timeLeft}</span> */}
            </p>
          </div>
          {/* COUNTDOWN TIMER 
          {timeLeft &&
            <div className="order-3 mt-2 w-full flex-shrink-0 sm:order-2 sm:mt-0 sm:w-auto">
              <span className="ml-1 text-white font-semibold">Ends in {timeLeft}</span>
            </div>
          } */}
          {/* ACTION BUTTON */} 
          {m.ctaURL &&
            <div className="order-3 mt-2 w-full flex-shrink-0 sm:order-2 sm:mt-0 sm:w-auto">
              <Link
                href={m.ctaURL}
                passHref
                className="w-full md:w-auto flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-2 text-sm font-medium text-brand-600 shadow-sm hover:bg-brand-50"
              >
                {m.ctaText}
              </Link>
            </div>
          }
          {/* CLOSE BUTTON */}
          <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
            <button
              type="button"
              onClick={close}
              className="-mr-1 flex rounded-md p-2 hover:bg-brand-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2"
            >
              <span className="sr-only">Dismiss</span>
              <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
            </button>
          </div>
        </div>
        }
      </div>
    </div>
  )
}
